import { ref } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-62b11c74"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = {
  class: "filter-list-content"
};
const _hoisted_3 = {
  class: "input-select-content"
};
const _hoisted_4 = {
  class: "filter-list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "产品信息", -1));
const _hoisted_6 = {
  class: "filter-list"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "主体/账号", -1));
const _hoisted_8 = {
  class: "filter-list"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "支付渠道", -1));
const _hoisted_10 = {
  class: "btn-content"
};
import { onMounted } from '@vue/runtime-core';
import { awaitWrap, getNode, OK } from '@/common';
import { queryFilterPayChnl } from '@/api/whitelist';
export default /*#__PURE__*/_defineComponent({
  __name: 'WhiteFilterBlock',
  emits: ['filterSubmit', 'setProductName'],
  setup(__props, {
    expose,
    emit
  }) {
    const dbtId = ref(null); // 产品名
    const accountId = ref(null); // 产品名
    const channel = ref(null); // 渠道
    const channelList = ref([]); // 渠道列表
    const filterSubmit = () => {
      let params = {
        payChnl: channel.value,
        fuzzy: dbtId.value,
        mchAccountName: accountId.value
      };
      emit('filterSubmit', params);
    }; // 搜索
    const init = () => {
      dbtId.value = null;
      channel.value = null;
      accountId.value = null;
      filterSubmit();
    }; // 初始化
    const getChnl = async () => {
      const [err, data] = await awaitWrap(queryFilterPayChnl());
      if (data && data.code === OK) {
        channelList.value = data.data.map(item => ({
          label: item.payChnlName,
          value: item.payChnl
        }));
        channelList.value.unshift({
          label: '全部',
          value: null
        });
      }
      if (err) {}
    }; // 获取支付渠道
    onMounted(() => {
      init();
      getChnl();
    });
    expose({
      channel,
      dbtId
    });
    return (_ctx, _cache) => {
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_input_search, {
        "allow-clear": "",
        placeholder: "产品名称/DBTID",
        value: dbtId.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => dbtId.value = $event),
        valueModifiers: {
          trim: true
        },
        onSearch: filterSubmit
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_a_input_search, {
        "allow-clear": "",
        placeholder: "主体/账号",
        value: accountId.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => accountId.value = $event),
        valueModifiers: {
          trim: true
        },
        onSearch: filterSubmit
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_select, {
        onChange: filterSubmit,
        value: channel.value,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => channel.value = $event),
        placeholder: "请选择",
        options: channelList.value,
        "get-popup-container": _unref(getNode)
      }, null, 8, ["value", "options", "get-popup-container"])])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_a_button, {
        onClick: init
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: filterSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]);
    };
  }
});